import type { AppRegistryPage } from '@plato/app-meta/ai-meta';
import { usePageAiMeta } from '@plato/app-shared/hooks/use-page-ai-meta';
import { useTranslation } from 'react-i18next';
import { DraftHeaderPage } from '../../../features/sales-draft-new/views/draft-header-page.tsx';

export function useDraftHeaderAiMeta(): AppRegistryPage {
    const { t } = useTranslation();
    return usePageAiMeta({
        path: '/drafts/:draft_id/header',
        title: t('sales_draft__stepper__header', { ns: 'sales-draft' }),
        requiresTransactionDrafts: true,
        description:
            'The header step of a sales draft: billing and shipping address, contact person, ' +
            'delivery date for an order or due date for a quote, shipping type, document type, PO ' +
            'number and notes. The user also submits the draft to the ERP from this step. Some ' +
            'tenants do not have drafts; if the user cannot see the page, it is not enabled for them.',
    });
}

function DraftHeader() {
    return <DraftHeaderPage />;
}

export default DraftHeader;
